import { Quotation } from '../../../types/api/Quotation'
import { useApi } from '../../../hooks/useApi'
import { useGlobalDispatch } from '../../../stateProviders/GlobalStateProvider'
import { ActionButtons } from '../../../globalComponents/modal/ActionButtons'
import React from 'react'
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Box, styled } from '@mui/material'
import { Modal } from 'src/globalComponents/modal/Modal'
import { TbTrash } from 'react-icons/tb'
import { toast, toastError } from 'src/Toaster/Toast';
import { useQuotationsCount } from '../../../contexts/QuotationsCountContext';

interface DeleteQuotationModalProps {
  quotation: Quotation | undefined;
  setQuotations: React.Dispatch<React.SetStateAction<Quotation[]>>;
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteQuotationModal: React.FC<DeleteQuotationModalProps> = ({
    quotation,
    setQuotations,
    modalOpen,
    setModalOpen,
}) => {
  if (!quotation) { return null; }
  const api = useApi();
  const globalDispatch = useGlobalDispatch();
  const { refreshCounts } = useQuotationsCount();

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      modalBody={
        <Stack direction="column" alignItems="center" spacing={4}>
          <Box
            sx={{
              width: '72px',
              height: '72px',  
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#FBF2F2',
              borderRadius: '50%',
              padding: 1,
            }}
          > 
            <StyledTbTrash/>
          </Box>
          <Stack direction="column" alignItems="center" spacing={2}>
            <Typography variant="h2" fontWeight="bold" align='center'>
              Are you sure you want to delete
              <Typography variant="h2" fontWeight="bold">
                {quotation.projectName}?
              </Typography>
            </Typography>
            <Typography variant="sm" color="text.secondary" align="center" sx={{ width: '80%' }}>
              After deletion, it will no longer be available in your quotes.
            </Typography>
          </Stack>
        </Stack>
      }
      modalFooter={
        <ActionButtons
          confirmButtonText="Delete"
          confirmButtonStyle="warning"
          confirmCallback={async () => {
            if (quotation._id) {
              const response = await api.quotations.deleteQuotation(quotation._id)
              if (response.errored) {
                  toastError({
                    title: 'Error',
                    description: response.error?.message || 'Error deleting quotation',
                  })
              }
              const quotations = await api.quotations.getQuotations();
              await refreshCounts();
              toast({
                title: 'Quotation deleted',
                description: `${quotation.projectName} has been deleted successfully.`,
              });
              globalDispatch({ quotations: quotations.rows });
              setQuotations(quotations.rows);
              setModalOpen(false);
            } else {
              console.error('Quotation ID is undefined');
            }
          }}
          cancelCallback={() => setModalOpen(false)}
        />
      }
    />
  );
}

const StyledTbTrash = styled(TbTrash)(({ theme }) => ({
  width: '34px',
  height: '37px',
  color: theme.palette.error.main,
}));

export default DeleteQuotationModal